import { Metamodel } from '../../base/model';
import { AdsDataset, IAdsDatasetArgs, AdsDatasetType } from '../../../../lib/model/dataShare/Datasets/AdsDatasetModel';
import { IAdsAdlsGen2CommonProperties } from '../../../../lib/model/dataShare/Datasets/AdsAdlsGen2CommonProperties';

type IAdsAdlsGen2FilesystemDatasetProperties = IAdsAdlsGen2CommonProperties;

export type IAdsAdlsGen2FilesystemDatasetArgs = Omit<IAdsDatasetArgs<IAdsAdlsGen2FilesystemDatasetProperties>, 'datasetType'>;

@Metamodel.model({
    name: 'AdsAdlsGen2FilesystemDataset'
})
export class AdsAdlsGen2FilesystemDataset extends AdsDataset<IAdsAdlsGen2FilesystemDatasetProperties> {
    public constructor(args: IAdsAdlsGen2FilesystemDatasetArgs) {
        super({
            ...args,
            datasetType: AdsDatasetType.AdlsGen2Filesystem
        });
    }

    public get resourceId(): string {
        return `${this.properties.storageAccountName}/${this.properties.filesystemName}`;
    }
}
